module.exports = __webpack_public_path__ + "fa-brands-400.woff?2ef8ba3410dcc71578a880e7064acd7a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff
// module id = 224
// module chunks = 0